/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Application language
 * @export
 * @enum {string}
 */

export const AppLanguageDto = {
    Polish: 'POLISH',
    English: 'ENGLISH',
    French: 'FRENCH'
} as const;

export type AppLanguageDto = typeof AppLanguageDto[keyof typeof AppLanguageDto];



